import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { GET_RACE_PROGRESS } from '../actions/getRaceProgress';
import { TAction } from '../actions/types/action';
import { TRaceProgressClientState } from '../libs/store';

function getInitialState() {
  return {
    instances: {}
  };
}

export default function raidRankings(
  state: Partial<TRaceProgressClientState> = getInitialState(),
  action: TAction<any>
): Partial<TRaceProgressClientState> {
  switch (action.type) {
    case GET_RACE_PROGRESS: {
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.payload.instanceId || 'default']: action.payload.raceProgress
        }
      };
    }
    case LOCATION_CHANGE: {
      if (action.payload.isFirstRendering) {
        return state; // server render may have pre-populated state, so we don't want to nuke it
      }
      return getInitialState();
    }
    default:
      return state;
  }
}
